
export const Environment ={

    baseURL:'https://beneshtyapi.geniussystemapi.com',
    project: 'storeAssestante'  
 }

export default Environment